<template>
    <div class="container">
        <b-row class="login justify-content-center">
            <b-col lg="5" md="8" sm="12">
                <div class="login-box">
                    <img src="../assets/logo.png" height="39" width="179"/>

                    <b-form>
                        <b-form-group label="Username" label-for="username">
                            <b-form-input id="username" v-model="credentials.username" required v-on:keyup.native="submitByKey"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Password" label-for="password">
                            <b-form-input id="password" type="password" v-model="credentials.password" required v-on:keyup.native="submitByKey"></b-form-input>
                        </b-form-group>
                    </b-form>

                    <b-button variant="success" @click="submit()">Login</b-button>

                    <div class="error" v-if="error">{{error}}</div>
                </div>
                <div class="signup-box">
                    <h4>Don't have an account?</h4>
                    <b-button variant="primary" :to="{ name: 'Signup'}">Signup</b-button>

                </div>

            </b-col>
        </b-row>
    </div>
</template>

<script>
    import router from '../router';
    import auth from '../services/auth';

    export default {
        name: "login",
        data() {
            return {
                credentials: {
                    username: '',
                    password: ''
                },
                error: ''
            }
        },
        methods: {
            submit: function() {
                auth.login(this.credentials).then(() => {
                    router.push({name: 'Welcome'});
                }, err => {
                    this.error = err;
                });
            },
            submitByKey: function(event) {
                if (event.which === 13) {
                    this.submit();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    img {
        margin: 0 0 40px -5px;
    }
    .login {
        margin-top: 100px;

        .signup-box {
            font-family: "Roboto", sans-serif;

            margin-top: 30px;
            padding: 0 30px 30px;
            border: 2px solid #017BFF;
            border-radius: 5px;

            h4 {
                margin: 20px 0;
                font-size: 20px;
            }
        }

        .login-box {
            font-family: "Roboto", sans-serif;

            padding: 30px;
            border: 2px solid transparent;
            border-radius: 5px;

            .error {
                padding: 10px 20px;
                border: 2px solid #ff0203;
                color: white;
                border-radius: 5px;
                margin-top: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/login.vue